// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 段落样式设置-----------开始------------------------- */\n[data-v-7962e368] .ql-container {\n  height: 330px !important;\n  overflow: visible !important;\n  /* overflow-y: scroll; */\n}\n", ""]);
// Exports
module.exports = exports;
